/**
 * Collapsible raw response. The demo is an architecture conversation with an engineer, so the
 * actual wire payload has to be available — a summary that cannot be checked against the JSON
 * is an assertion, not evidence.
 */

import ExpandableSection from '@cloudscape-design/components/expandable-section';
import Box from '@cloudscape-design/components/box';

export default function RawJson({ label = 'Raw API response', value }) {
  return (
    <ExpandableSection headerText={label} variant="footer">
      <Box variant="code">
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontSize: '12px' }}>
          {JSON.stringify(value, null, 2)}
        </pre>
      </Box>
    </ExpandableSection>
  );
}
